<template>
  <base-content-block>
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <div v-if="loading">
        <base-spinner></base-spinner>
      </div>
      <div v-else-if="!patient">{{ $t('src/pages/patientedit.5898') }}</div>
      <div v-else>
        <patient-form v-model="patient" :saving="saving" @submit="save"></patient-form>
      </div>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { savedMessage } from '@/mixins/saved-message.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'PatientEdit',
  mixins: [contentTpl, savedMessage, systemUnavailable],
  components: {
    PatientForm: () => import('@/components/PatientForm.vue'),
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  data: () => ({
    patient: {},
    saving: false,
    loading: true
  }),
  computed: {
    patientId() {
      return this.$route.params.id
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.loadPatient()
      }
    }
  },
  mounted() {
    this.loadPatient()
  },
  methods: {
    loadPatient() {
      this.patient = null
      this.loading = true
      http
        .get('/patients/' + this.patientId, {
          headers: {
            redirect404: true
          }
        })
        .then(response => {
          this.patient = response.data
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false))
    },
    save() {
      this.saving = true

      http
        .patch('/patients/' + this.patientId, this.patient)
        .then(response => {
          if (response.data) {
            this.patient = response.data
            this.$emit('saved:data')
          } else {
            throw this.$t('errorMessage.unexpectedError')
          }
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          console.log(error)
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
